<svelte:options tag="and-sub-menu"></svelte:options>
<style style type="text/scss" lang="scss">
  @import "../../../global.scss";

  .sub-menu {
    float: none;
    @include fontSize(14px);
    color: black;
    padding: toRem(12px) toRem(16px) 0 toRem(16px);
    text-decoration: none;
    display: block;
    color: $and-charcoal;
    font-family: "Poppins", sans-serif;
    text-align: left;

    @include large-screen {
      padding: toRem(14px) toRem(16px);
    }
  }

  .sub-dropdown .sub-dropbtn {
    @include fontSize(14px);
    border: none;
    outline: none;
    color: $and-charcoal;
    padding: toRem(14px) toRem(16px);
    background-color: inherit;
    font-family: "Poppins", sans-serif;
    margin: 0;
    text-align: left;
  }

  .sub-dropdown:hover .sub-dropbtn {
    font-weight: bold;
  }

  .sub-dropdown-content {
    display: none;
    position: absolute;
    color: $and-charcoal;
    min-width: toRem(160px);
    box-shadow: toRem(0px) toRem(8px) toRem(16px) toRem(0px) rgba(0, 0, 0, 0.2);
    background-color: white;;
    z-index: 1;
    left: 100%;
    top: 0;
  }

  .sub-dropdown-content a {
    float: none;
    color: black;
    padding: toRem(12px) toRem(16px);
    text-decoration: none;
    display: block;
    font-family: "Poppins", sans-serif;
    text-align: left;
  }

  @include large-screen {
    .sub-menu:hover {
      background-color: $and-blue;
      font-weight: bold;
    }
    .sub-dropdown-content a:hover {
      background-color: $and-blue;
    }

    .sub-dropdown:hover,
    .sub-dropbtn:hover {
      background-color: $and-blue;
    }
  }

  .sub-dropdown:hover .sub-dropdown-content {
    display: block;
  }

  .sub-dropdown {
    position: relative;
  }
</style>

<script>
  import Desktop from "../../../breakpoints/Desktop.svelte";
  export let text = "";

  export let href = "";

  export let id = 'and-submenu';

  export let target = '';
</script>
{#if href == ''}
<div id="{id}" class="sub-dropdown">
  <button class="sub-dropbtn">{text}</button>

  <Desktop>
    <div class="sub-dropdown-content">
      <slot>
        <b>No Sub menu</b>
      </slot>
    </div>
  </Desktop>
</div>
{/if} {#if href != ''}
<a id="{id}" class="sub-menu" target="{target}" href="{href}">{text}</a>
{/if}
